import InputGroup from '../../ui-components/InputGroup'
import UserAvatar from '../../../preact-components/User/UserAvatar'
import Icon, { IconType } from '../../../preact-components/assets'

export interface FilterOptionItem {
  id: string | number
  name: string
  value: string | number | boolean
  icon?: IconType
  avatar?: string
}

const FilterOption = ({ item, data, onFilterOptionSelection, type, key, isSelectAll }: { item: FilterOptionItem, data: any, type?: string, key?: string | number, isSelectAll?: boolean, onFilterOptionSelection: (payload: string[]) => void }) => {
  return (
    <InputGroup
      inline
      key={key || item.id}
      value={String(item.value)}
      title={<div>
        {typeof item.avatar !== 'undefined' && <UserAvatar disableLink disablePopup user={item} />}
        {item.icon && <Icon icon={item.icon} />}
        {item.name}
      </div>}
      formGroupClasses='overview__filters-box-filter'
      checked={isSelectAll || data.some((value: string) => String(value) === String(item.value))}
      type={type === 'radio' ? 'radio' : 'checkbox'}
      onChangeCheckbox={type === 'radio'
        ? (e) => {
            onFilterOptionSelection([e.target.value])
          }
        : (e) => {
            const value = e.target.value
            const checked = e.target.checked
            const payload = checked
              ? [...data, value]
              : data.filter((x: string) => String(x) !== value)
            onFilterOptionSelection(payload)
          }}
    />
  )
}

export default FilterOption
